import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { mockData } from '../../mock';

const Footer = () => {
  return (
    <footer className="relative py-20 px-6 border-t border-[#1e293b]/50 bg-gradient-to-b from-[#0B0F1A] to-[#0a0d14]">
      {/* Subtle grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)`,
        backgroundSize: '50px 50px'
      }}></div>
      
      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Main footer content */}
        <div className="grid md:grid-cols-12 gap-12 lg:gap-16 mb-16">
          {/* Logo Column - 4 columns */}
          <div className="md:col-span-4 flex items-start justify-center md:justify-start">
            <div className="flex flex-col items-center md:items-start">
              <img 
                src="/loading-logo-new.png" 
                alt="MeshWeb" 
                className="h-56 w-56 md:h-64 md:w-64 lg:h-72 lg:w-72 object-contain transition-transform duration-300 hover:scale-105" 
              />
            </div>
          </div>
          
          {/* Contact Column - 4 columns */}
          <div className="md:col-span-4 flex flex-col items-center md:items-start">
            <h3 className="text-sm font-semibold text-[#e2e8f0] uppercase tracking-wider mb-6 relative">
              Contact
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF]"></span>
            </h3>
            <div className="space-y-4">
              <a 
                href={`mailto:${mockData.contact.email}`} 
                className="flex items-center gap-3 text-[#94a3b8] hover:text-[#3b82f6] transition-all duration-300 group"
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#1e293b]/50 flex items-center justify-center group-hover:bg-[#2F6BFF]/10 transition-colors">
                  <Mail className="h-4 w-4 text-[#60a5fa] group-hover:text-[#3b82f6]" />
                </div>
                <span className="text-sm">{mockData.contact.email}</span>
              </a>
              <a 
                href={`tel:${mockData.contact.phone}`} 
                className="flex items-center gap-3 text-[#94a3b8] hover:text-[#3b82f6] transition-all duration-300 group"
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#1e293b]/50 flex items-center justify-center group-hover:bg-[#2F6BFF]/10 transition-colors">
                  <Phone className="h-4 w-4 text-[#60a5fa] group-hover:text-[#3b82f6]" />
                </div>
                <span className="text-sm">{mockData.contact.phoneDisplay}</span>
              </a>
            </div>
          </div>
          
          {/* Quick Links Column - 4 columns */}
          <div className="md:col-span-4 flex flex-col items-center md:items-start">
            <h3 className="text-sm font-semibold text-[#e2e8f0] uppercase tracking-wider mb-6 relative">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF]"></span>
            </h3>
            <nav className="flex flex-col space-y-3">
              <a 
                href="#services" 
                className="text-[#94a3b8] hover:text-[#3b82f6] transition-colors duration-300 text-sm hover:translate-x-1 inline-block"
              >
                Services
              </a>
              <a 
                href="#portfolio" 
                className="text-[#94a3b8] hover:text-[#3b82f6] transition-colors duration-300 text-sm hover:translate-x-1 inline-block"
              >
                Portfolio
              </a>
              <a 
                href="#pricing" 
                className="text-[#94a3b8] hover:text-[#3b82f6] transition-colors duration-300 text-sm hover:translate-x-1 inline-block"
              >
                Pricing
              </a>
              <a 
                href="#contact" 
                className="text-[#94a3b8] hover:text-[#3b82f6] transition-colors duration-300 text-sm hover:translate-x-1 inline-block"
              >
                Contact
              </a>
            </nav>
          </div>
        </div>
        
        {/* Copyright section */}
        <div className="pt-8 border-t border-[#1e293b]/50">
          <p className="text-center text-[#64748b] text-sm">
            © 2025 MeshWeb. Built with care for local businesses.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
